const setMetaTags = (componentInstance, metas) => {
  const {
    props: {
      FRN_flux
    }
  } = componentInstance;

  // make sure FRN_flux is not undefined before call getActions.
  if (FRN_flux) FRN_flux.getActions('Helmet').updateMetas({ metas });
};

export default setMetaTags;



// WEBPACK FOOTER //
// ./app/lib/frankly/setMetaTags.js